module.exports = __webpack_public_path__ + "static/media/movimento-por-uma-cultura-de-doação.2ed20fd6.png";